import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './routes'
import App from './App.vue'
import axiosInstance from './api/axiosInstance.js'
import VueAxios from 'vue-axios'
import '@snowshoe-frontend/shared-styles'
import { setupI18n } from '@/helpers/setup-i18n'
import resetPlugin from '@/plugins/reset-pinia'

const pinia = createPinia()
pinia.use(resetPlugin)

const app = createApp(App)
app.use(setupI18n())
app.use(pinia)
app.use(router)
app.use(VueAxios, axiosInstance)

app.mount('#app')
